export enum TripleStateBoolean {

  All = 0,
  True = 1,
  False = 2,
  
}


